import { IconButton } from '@socialchorus/shared-ui-components';
import { useEffect, useRef, useState } from 'react';

const TEXT_COLOR_PRESETS = [
  '#000000',
  '#434343',
  '#666666',
  '#999999',
  '#CCCCCC',
  '#FFFFFF',
  '#FF0000',
  '#FF4D00',
  '#FF9900',
  '#FFD500',
  '#FFFF00',
  '#A6FF00',
  '#00FF00',
  '#00FF99',
  '#00FFFF',
  '#0099FF',
  '#0000FF',
  '#9900FF',
  '#FF00FF',
  '#FF0099',
  '#C00000',
  '#A04000',
  '#C09000',
  '#008000',
  '#004080',
  '#400080',
];

// mostly vibecoded PLACEHOLDER - replace it with a real color picker when we have a design
export default function ToolbarColorPicker({
  color,
  onChange,
}: {
  color: string;
  onChange: (color: string) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div className="lexical-color-picker" ref={wrapperRef}>
      <IconButton
        style={{ color: color }}
        iconName="format_color_text"
        onClick={() => setIsOpen((prev) => !prev)}
        title="Text color"
        size="extra-compact"
      />
      {isOpen && (
        <div className="lexical-color-picker__dropdown">
          <div className="lexical-color-picker__presets">
            {TEXT_COLOR_PRESETS.map((preset) => (
              <button
                key={preset}
                type="button"
                className={`lexical-color-picker__swatch${
                  color.toUpperCase() === preset
                    ? ' lexical-color-picker__swatch--active'
                    : ''
                }`}
                style={{ backgroundColor: preset }}
                onClick={() => {
                  onChange(preset);
                  setIsOpen(false);
                }}
                title={preset}
                aria-label={`Set text color to ${preset}`}
              />
            ))}
          </div>
          <div className="lexical-color-picker__custom">
            <label>
              Custom:
              <input
                type="color"
                value={color}
                onChange={(e) => {
                  onChange(e.target.value);
                }}
              />
            </label>
          </div>
        </div>
      )}
    </div>
  );
}
